import { render, staticRenderFns } from "./insurance_apply.vue?vue&type=template&id=92f92ad4&scoped=true&"
import script from "./insurance_apply.vue?vue&type=script&lang=js&"
export * from "./insurance_apply.vue?vue&type=script&lang=js&"
import style0 from "./insurance_apply.vue?vue&type=style&index=0&id=92f92ad4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f92ad4",
  null
  
)

export default component.exports